<template>

  <memlist-modal size="xl" ref="member-event-editor-modal">
  
    <MemberEditorCompactModal
      v-if="participant"
      ref="member-editor-compact-modal"
      :member_id="participant.member_id"
    />

    <PersonEditorModal
      v-if="participant"
      ref="person-modal"
      :person_id="participant.person_id"
      @updated="updated_person"
    />

    <form>

      <memlist-card>

        <m-row>
          <m-col lg="12">
            <QuestionRadioOptions 
              :item="member_type_radio_options"
              :preselected="selected_member_type"
              @selected="member_type_selected"
            />
          </m-col>
        </m-row>

      
      <div v-if="selected_member_type === 'MEMBER'">
        <m-row class="mt-4">
          <m-col lg="12">
      
            <p style="font-weight: bold;">{{ $t('EVENT.SEARCH_SELECT_MEMBER') }}</p>
            <QuickSearchMemberWidget
              @member_selected="member_selected"
            />
          </m-col>
        </m-row>
      </div>

      <div v-else-if="selected_member_type === 'PERSON'">
        <m-row class="mt-4">
          <m-col lg="12">
      
            <p style="font-weight: bold;">{{ $t('EVENT.SEARCH_SELECT_PERSON') }}</p>
            <QuickSearchPersonWidget
              @personSelected="person_selected"
            />
          </m-col>
        </m-row>
      </div>

      <div v-else>
        <m-row class="mt-4">
          <m-col lg="12">
            <p>Välj deltagartyp för att fortsätta</p>
          </m-col>
        </m-row>
      </div>
      
      </memlist-card>

      <memlist-card class="mt-4" v-if="local_item.person_id || local_item.member_id">
        <m-row>
          <m-col>
            <memlist-text-input
              id="participant_name"
              name="participant_name"
              :title="$t('EVENT.PARTICIPANT')"
              layout="vertical"
              validation_type="TEXT"
              v-model="participant_name"
              :disabled="true"
            />
          </m-col>
          <m-col>

            <memlist-icon-button
              style="margin-top: 26px; height: 36px;"
              icon="fa fa-user"
              :text="$t('COMMON.EDIT')"
              variant="primary"
              @click="edit_participant_clicked"
            />

          </m-col>
        </m-row>

      </memlist-card>
      
      <memlist-card class="mt-4" v-if="local_item.person_id || local_item.member_id">
        
        <m-row>
          <m-col lg="12">
            
            <p class="mt-4"><b>{{ $t('EVENT.PARTICIPANTS_TICKETS_INFO') }}</b></p>
            
            <MemberEventTicketRow
              v-for="(prop, index) in local_item.tickets"
              :key="index"
              :item="prop"
              :event="event"
              :index="index"
              @delete="delete_ticket"
              @updated="update_ticket"
            />

            <p v-if="!local_item.tickets || local_item.tickets.length === 0">-- Inga biljetter --</p>
            <p class="mt-4"><a @click.prevent="add_ticket_row" href="#">+ {{ $t('EVENT.ADD_TICKET') }}</a></p>

          </m-col>
        </m-row>

      </memlist-card>

      <memlist-card class="mt-4" v-if="local_item.member_event_id">
        
        <m-row class="mt-4">
          <m-col lg="6">
            <memlist-checkbox
              class="mt-2"
              :text="$t('EVENT.CHECKED_IN')"
              v-model="local_item.checkedin"
            />
          </m-col>

          <m-col lg="6">
            <memlist-spinner-icon-button
              ref="send-ticket-button"
              :text="$t('EVENT.SEND_TICKET')" 
              icon="menu-icon flaticon2-mail"
              @click="send_ticket_clicked"
            />
            
          </m-col>

        </m-row>

        <m-row>
          
        </m-row>  

      </memlist-card>

      <div v-if="validate">
        <memlist-inline-alert class="mt-8" v-if="!local_item.member_id && !local_item.person_id" show variant="danger"
          >{{ $t('EVENT.PARTICIPANT_MISSING') }}</memlist-inline-alert
        >

        <memlist-inline-alert class="mt-8"v-if="!local_item.tickets || local_item.tickets.length === 0" show variant="danger"
          >{{ $t('EVENT.TICKET_MISSING') }}</memlist-inline-alert
        >

        <memlist-inline-alert class="mt-8" v-if="error === 'full'" show variant="danger"
          >{{$t('EVENT.EVENT_FULL')}}</memlist-inline-alert
        >

        <memlist-inline-alert class="mt-8" v-if="error === 'request'" show variant="danger"
          >{{$t('EVENT.MISSING_FIELDS')}}</memlist-inline-alert
        >

        <memlist-inline-alert class="mt-8" v-if="error === 'undefined'" show variant="danger"
          >{{$t('EVENT.INTERNAL_ERROR')}}</memlist-inline-alert
        >
      </div>

      <RightSaveButton
        ref="save-button"
        :text="$t('COMMON.SAVE')"
        @clicked="submit_clicked()"
        class="mb-4 mt-4 mx-right"
      />

    </form>
  </memlist-modal>

</template>


<script>

import TicketSelectRow from '@/view/pages/members/public/TicketSelectRow.vue';
import QuickSearchMemberWidget from '@/view/pages/ml/search/QuickSearchMemberWidget.vue';
import QuickSearchPersonWidget from '@/view/pages/ml/search/QuickSearchPersonWidget.vue';
import MemberEventTicketRow from '@/view/pages/ml/events/MemberEventTicketRow.vue';
import QuestionRadioOptions from '@/view/components/questions/QuestionRadioOptions.vue';

import ButtonWithLoader from '@/view/components/buttons/ButtonWithLoader.vue';
import RightSaveButton from '@/view/components/buttons/RightSaveButton.vue';
import { mapGetters } from 'vuex';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import axios from 'axios';


export default {
  name: 'MemberEventEditor',
  props: ['item','event'],
  emits: ['created', 'updated', 'change', 'deleteMemberClicked'],
  mixins: [ toasts ],
  components: {
    QuickSearchMemberWidget,
    QuickSearchPersonWidget,
    ButtonWithLoader,
    RightSaveButton,
    TicketSelectRow,
    QuestionRadioOptions,
    MemberEventTicketRow
  },
  computed: {
    participant_name() {
      if (!this.participant) {
        return this.$t('EVENT.NO_PARTICIPANT');
      }

      if (this.participant.firstname) {
        return (this.participant.firstname || '') + ' ' + (this.participant.lastname || '');
      }

      return this.participant.email || this.participant.phone || '';
    },
    
    ...mapGetters(['currentCompanyId', 'currentPeriodId']),
    
  },
  watch: {
    item: {
      deep: true, // check properties of the form, not just the form reference (example.name for example)
      async handler(val) {
        if (this.item) {
          this.local_item = { ...this.item };
        
          if (this.local_item.invoice_same_as_participant === undefined) {
            this.local_item.invoice_same_as_participant = true;
          }

          if (this.local_item.member_id) {
            this.selected_member_type = 'MEMBER';
            this.participant = this.local_item.member;
          }
          else if (this.local_item.person_id) {
            this.selected_member_type = 'PERSON';
            this.participant = this.local_item.person;
          }
          else {
            this.selected_member_type = null;
            this.participant = null;
          }
        }
        else {
          this.local_item = {
            event_id: this.event.event_id
          }
          this.participant = null;
        }

        await this.load_tickets(this.event.event_id);

        this.validate = false;
      },
      immediate: true
    },
    
  },
  data() {
    return {
      validate: false,
      participant: null,
      local_item: {},
      member_type_radio_options: {
        name: this.$t('EVENT.PARTICIPANT_TYPE'),
        options: [ { value: 'MEMBER', text: this.$t('COMMON.MEMBER') }, { value: 'PERSON', text: this.$t('COMMON.PERSON') } ]
      },

      selected_member_type: null,
    };
  },
  async mounted() {
    this.validate = false;
  },
  methods: {
    updated_person(person) {
      this.participant = person;
    },
    edit_participant_clicked() {
      if (this.selected_member_type === 'MEMBER') {
        this.$nextTick(()=>{
          this.$refs['member-editor-compact-modal'].show();
        });
      }
      else {
        this.$nextTick(()=>{
          this.$refs['person-modal'].show();
        });
        
      }
    },
    show() {
      this.$refs['member-event-editor-modal'].show();
    },
    hide() {
      this.$refs['member-event-editor-modal'].hide();
    },
    
    send_ticket_clicked() {
      this.send_ticket();
    },

    add_ticket_row() {
      if (!this.local_item.tickets) {
        this.local_item.tickets = [];
      }

      this.local_item.tickets.push({})

      this.local_item = { ...this.local_item };  
    },

    delete_ticket(item, index) {
      this.local_item.tickets.splice(index, 1);
      this.local_item = { ...this.local_item };
    },
    update_ticket(item, index) {
      this.local_item.tickets[index] = item;
      this.local_item = { ...this.local_item };
    },
    
    member_selected(member) {
      console.log('member', member);
      this.local_item.member_id = member.member_id;

      this.local_item = { ...this.local_item };

      this.participant = member;
    },

    person_selected(person) {
      console.log('person', person);
      this.local_item.person_id = person.person_id;

      this.local_item = { ...this.local_item };

      this.participant = person;
    },
    
    
    member_type_selected(value) {
      this.selected_member_type = value;
    },
    add_ticket_clicked() {

    },
    async submit_clicked() {

      this.validate = true;

      if (this.local_item.member_event_id) {
        this.$refs['save-button'].stop();

        await this.put_member_event(this.local_item.member_event_id, this.local_item);
        this.toastr('success', this.$t('COMMON.OK'), this.$t('EVENT.UPDATED'));
        this.$emit('updated', this.local_item);

        return;
      }

      try {

        if (this.local_item.send_ticket_email === undefined) {
          this.local_item.send_ticket_email = false;
        }

        this.local_item.is_member = this.selected_member_type === 'MEMBER';

        const data = await this.post_member_event(this.event.event_id, this.local_item);

        if (data) {
          this.local_item = data;
          this.$emit('created', data);
          this.error = '';

          this.$refs['save-button'].stop();

          return;
        }
      }
      catch (err) {
        if (err === 'full') {
          this.error = 'full';
        }
        else if (err === 'request') {
          this.error = 'request';
        }
        else {
          this.error = 'undefined';
          console.error(err);
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('EVENT.UNABLE_ADD_MEMBER_PERSON'));
        }
      }

      this.$refs['save-button'].stop();

    },

    async send_ticket() {
      try {
        const res = await axios.post(`/member_event/admin/send_ticket/${this.local_item.member_event_id}`);

        if (res.status === 201) {
          this.toastr('success', this.$t('COMMON.OK'), this.$t('EVENT.SUCCESS_SEND_TICKET'));
          this.$refs['send-ticket-button'].stop();

          return;
        }
      }
      catch (err) {
        console.error('send_ticket error', err);
      }

      this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('EVENT.ERROR_SEND_TICKET'));

      this.$refs['send-ticket-button'].stop();
    },

    async load_tickets(event_id) {
      try {
        const res = await axios.get(`/events/${event_id}/tickets`);
      
        if (res.status === 200) {
          this.ticket_items = res.data;
          this.ticketOptions = this.ticket_items.map(i => ({ text: i.name, value: i.id }));
        }
      }
      catch (err) {
        console.error('load_tickets', err);
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('EVENT.UNABLE_LIST_TICKETS'));
      }
      
    },

    async put_member_event(id, data) {
      try {
        const res = await axios.put(`/member_event/${id}`, data);

        if (res.status === 204) {
          return data;
        }

        if (res.status === 400) {
          throw 'invalid request';
        }

        if (res.status === 409) {
          this.error = 'full';
        }
        
      }
      catch (err) {
        console.error('put_member_event error', err);
      }

      throw 'error';
    },

    async post_member_event(event_id, form) {
      try {
        const res = await axios.post(`/member_event/admin_signup/${event_id}`, { ...form, event_id: event_id });

        if (res.status === 201) {
          return res.data;
        }

        if (res.status === 400) {
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('COMMON.UNABLE_UPDATE'));
        }
        else if (res.status === 409) {
          this.error = 'full';
        }

      } 
      catch (err) {
        console.error('post_member_event err', err);
      }

      throw 'error';
    },

  }
};
</script>
